import HomePage from '@/components/home-page/HomePage';

export default function _HomePage() {
  return <HomePage />;
}
